<template>
  <div class="plan">
    <plan-title />
    <plan-control :planId=id :isFull=false />
    <course />
    <plan-price />
    <plan-control :planId=id :isFull=true />
  </div>
</template>

<script>
import Course from '../components/organisms/Course'
import PlanControl from '../components/organisms/PlanControl'
import PlanTitle from '../components/organisms/PlanTitle'
import PlanPrice from '../components/organisms/PlanPrice'

export default {
  components: {
    PlanTitle,
    Course,
    PlanControl,
    PlanPrice
  },
  data () {
    return {
      id: this.$route.params.id
    }
  },
  created () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('plans/fetchPlan', this.id)
      .then(() => {
        this.$store.dispatch('tickets/fetchAll')
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      })
      .catch(() => {
        this.$alert({
          message: this.$t('tour_not_found_plan'),
          success: () => {
            this.$router.push({ path: '/plans' })
          }
        })
      })
  }
}
</script>
